import React from 'react'
import './student-onboarding-card-modal-fall-2023.css'
import axios from 'axios';
import { MdClose } from 'react-icons/md';
import NoteAreaFall2023 from './NoteAreaFall2023/NoteAreaFall2023';
import LooksLikeYouAreDonePopup from '../WorfklowCardModal2023/LooksLikeYouAreDonePopup/LooksLikeYouAreDonePopup';
import FamilyInfoGutter from './FamilyInfoGutter/FamilyInfoGutter';
import ModalAreaFall2023 from './ModalAreaFall2023/ModalAreaFall2023';
import { deleteTheCard } from './ModalAreaFall2023/modalAreaFunctionsFall2023';
import { getRequestHeaders } from '../api';
import { baseUrl } from '../assets/Animations';
import SimpleNotification from '../DanitComponents/Notifications/SimpleNotification';
import SchedulingHelper2024 from './SchedulingHelper2024/SchedulingHelper2024';
import DistanceSchedulerFall2025 from './DistanceSchedulerFall2025/DistanceSchedulerFall2025';
import CalendlyBookingDemo from '../CalendlyBookingDemo/CalendlyBookingDemo';
// import VagaroScheduler from './VagaroScheduler/VagaroScheduler';


const StudentOnboardingCardModalFall2023 = ({
    studentOnboardingModal, 
    setStudentOnboardingModal, 
    userData, createNoteFunc, 
    setRawStudentOnboardingCards, 
    setRawWaitlistFamilies, 
    getFamilyData, 
    setWaitlistEntities, 
    setIsConfettiExplosion, 
    setWarningPopup, 
    socket,
    setStudentOnboardingCardsInUse
}) => {
    const [areYouDonePopup, setAreYouDonePopup] = React.useState(false)
    const [copyConfirmationPopup, setCopyConfirmationPopup] = React.useState(false)
    const [schedulingHelperTeacherId, setSchedulingHelperTeacherId] = React.useState(false)
    const [teacherDistanceSuggestions, setTeacherDistanceSuggestions] = React.useState([])
    const [showVagaroScheduler, setShowVagaroScheduler] = React.useState(false)
    const [familyProfile, setFamilyProfile] = React.useState(false)
    const [showDistanceScheduler, setShowDistanceScheduler] = React.useState(false)
    const [showBookingDemo, setShowBookingDemo] = React.useState(false)
    const [saving, setSaving] = React.useState(false)
    const isMountedRef = React.useRef(true)

    React.useEffect(() => {
        return () => {
            isMountedRef.current = false
        }
    }, [])

    if (!studentOnboardingModal) {
        return null
    }

    // const refreshWaitlistFamiliesAndEntities = async () => {
    //     axios.get(`${baseUrl}/waitlist`, getRequestHeaders())
    //     .then((res) => setRawWaitlistFamilies(res.data))
    //     .catch((err) => console.log(err))
    //     axios.get(`${baseUrl}/waitlists`, getRequestHeaders())
    //     .then((res) => setWaitlistEntities(res.data))
    //     .catch((err) => console.log(err))
    // }

    const saveAndCloseTask = () => {
        if (saving) return
        setSaving(true)
        axios.put(`${baseUrl}/student-onboarding/${studentOnboardingModal.todoId}`, studentOnboardingModal, getRequestHeaders())
        .then((res) => {
            socket.emit('closeAndSaveStudentWorkflow', {emitter: userData.Name, data: res.data})
            setRawStudentOnboardingCards(prev => (prev.map((todo) => todo.todoId === res.data.todoId ? res.data : todo)))
            setStudentOnboardingModal(false)
        })
        .catch((err) => console.log(err))
        .finally(() => {
            if (isMountedRef.current) {
                setSaving(false)
            }
        })
    }

    const deleteAndCloseTask = () => {
        axios.delete(`${baseUrl}/student-onboarding/${studentOnboardingModal.todoId}`, getRequestHeaders())
        .then((res) => {
            socket.emit('closeAndDeleteStudentWorkflow', {emitter: userData.Name, data: res.data.todoId})
            //signalWorkflowBeingDeleted(res.data.todoId)
            setRawStudentOnboardingCards(prev => (prev.filter((todo) => todo.todoId !== res.data.todoId && todo)))
            setStudentOnboardingModal(false)
        })
        .catch((err) => console.log(err))
    }

    const checkForUnfinishedSubtasksAndThenProceed = () => {
        if (saving) return
        if(studentOnboardingModal.whichList === 'leaving') {
            socket.emit('closeAndSaveStudentWorkflow', {emitter: userData.Name, data: studentOnboardingModal})
            setStudentOnboardingModal(false)
        }
        if(studentOnboardingModal.whichList !== 'leaving') {
            studentOnboardingModal?.todoSubtasks?.filter((sub) => !sub.subtaskCompleted && sub).length > 0 ? saveAndCloseTask() : setAreYouDonePopup(true)
        }
    }

    const pushNewCardToOnBoardingCardsAndCloseModal = (newCard) => {
        //remove family from waitlist setRawWaitlistFamilies
        socket.emit('createStudentWorkflow', {emitter: userData.Name, data: newCard})
        setRawWaitlistFamilies(prev => (prev.filter((family) => family.familyId !== newCard.familyId && family)))
        setRawStudentOnboardingCards(prev => ([...prev, newCard]))
        setStudentOnboardingModal(false)
    }

    const pushNewCardAndRemoveGhostLeavingCardAndCloseModal = (newCard, oldCardId) => {
        //remove family from waitlist setRawWaitlistFamilies
        socket.emit('createStudentWorkflow', {emitter: userData.Name, data: newCard})
        socket.emit('closeAndDeleteStudentWorkflow', {emitter: userData.Name, data: oldCardId})
        setRawStudentOnboardingCards(prev => (prev.filter((todo) => todo.todoId !== oldCardId && todo)))
        setStudentOnboardingCardsInUse(prev => (prev.filter((todo) => todo.todoId !== oldCardId && todo)))
        setRawStudentOnboardingCards(prev => ([...prev, newCard]))
        setStudentOnboardingModal(false)
        setTimeout(() => {
            setRawWaitlistFamilies(prev => (prev.filter((family) => family.familyId !== newCard.familyId && family)))
        }, 1000)
    }

    const pushNewCardAndRemoveOldCardAndCloseModal = (newCard, oldCardId) => {
        //remove family from waitlist setRawWaitlistFamilies
        socket.emit('createStudentWorkflow', {emitter: userData.Name, data: newCard})
        socket.emit('closeAndDeleteStudentWorkflow', {emitter: userData.Name, data: oldCardId})
        setRawWaitlistFamilies(prev => (prev.filter((family) => family.familyId !== newCard.familyId && family)))
        setRawStudentOnboardingCards(prev => (prev.filter((todo) => todo.todoId !== oldCardId && todo)))
        setStudentOnboardingCardsInUse(prev => (prev.filter((todo) => todo.todoId !== oldCardId && todo)))
        setRawStudentOnboardingCards(prev => ([...prev, newCard]))
        setStudentOnboardingModal(false)
    }

    const removedCardAndCloseModal = async (card) => {
        setRawStudentOnboardingCards(prev => (prev.filter((todo) => todo.todoId !== card.todoId && todo)))
        setStudentOnboardingCardsInUse(prev => (prev.filter((todo) => todo.todoId !== card.todoId && todo)))
        socket.emit('closeAndDeleteStudentWorkflow', {emitter: userData.Name, data: card.todoId})
        //await refreshWaitlistFamiliesAndEntities()
        setStudentOnboardingModal(false)
        setWarningPopup(false)
    }

    const openFamilyProfileAndCloseWarningPopup = (card) => {
        getFamilyData(card.familyId)
        setWarningPopup(false)
    }

    const removedCardAndCloseModalOpenConfirmationPopup = async (card, confirmationPopupType) => {
        if(confirmationPopupType !== 'deleteCardOnly') {
            setRawStudentOnboardingCards(prev => (prev.filter((todo) => todo.todoId !== card.todoId && todo)))
            setStudentOnboardingModal(false)
        }
        //await refreshWaitlistFamiliesAndEntities()

        if(confirmationPopupType === 'inquired') {
            setWarningPopup({
                type: 'confirm',
                title: `You have changed the ${card.todoName} Family to "Inquired".`,
                message: `This has also deleted the associated inquiry card. If this is a mistake, you can visit the copy of their inquiry in the email.`,
                onConfirm: {
                    text: 'Ok',
                    action: () => setWarningPopup(false)
                },
                onCancel: {
                    text: 'See Family Profile',
                    action: () => openFamilyProfileAndCloseWarningPopup(card)
                }
            })
        } else if(confirmationPopupType === 'deleted') {
            setWarningPopup({
                type: 'confirm',
                title: `You have deleted the ${card.todoName} Family from the database.`,
                message: `This has also deleted the associated inquiry card. If this is a mistake, you can visit the copy of their inquiry in the email.`,
                onConfirm: {
                    text: 'Ok',
                    action: () => setWarningPopup(false)
                },
                onCancel: false
            })
        } else if (confirmationPopupType === 'deleteCardOnly') {
            setWarningPopup({
                type: 'warning',
                title: `Are you sure you want to delete this card?`,
                message: `This will not delete the family from the database.`,
                onConfirm: {
                    text: 'Ok',
                    action: () => deleteTheCard(card.todoId, removedCardAndCloseModal)
                },
                onCancel: {
                    text: 'Nevermind',
                    action: () => setWarningPopup(false)
                }
            })
        }
    }

    const updateExistingCardAndCloseModal = (card) => {
        socket.emit('closeAndSaveStudentWorkflow', {emitter: userData.Name, data: card})
        setStudentOnboardingCardsInUse(prev => (prev.filter((todo) => todo.todoId !== card.todoId && todo)))
        setRawStudentOnboardingCards(prev => (prev.map((todo) => todo.todoId === card.todoId ? card : todo)))
        setStudentOnboardingModal(false)
    }

    const removeCardAndLaunchConfetti = (card) => {
        socket.emit('closeAndDeleteStudentWorkflow', {emitter: userData.Name, data: card.todoId})
        setRawStudentOnboardingCards(prev => (prev.filter((todo) => todo.todoId !== card.todoId && todo)))
        setIsConfettiExplosion(true)
        setStudentOnboardingModal(false)
    }

    const simpleNotificationStyleObj = {
    
        backgroundColor: 'bg-green-100',
        titleColor: 'text-green-800',
        subtitleColor: 'text-green-800'
    
    }

    return(
        <div className='student-onboarding-card-modal-fall-2023__entire-screen-wrapper'>
            {/* {showVagaroScheduler && <VagaroScheduler familyProfile={familyProfile} setShowVagaroScheduler={setShowVagaroScheduler} />} */}
        {/* <div className='student-onboarding-card-modal-fall-2023__open-vagaro' onClick={() => setShowVagaroScheduler(true)}>OPEN VAGARO</div> */}
        <div className='student-onboarding-card-modal-fall-2023__wrapper' id='student-onboarding-card-modal-fall-2023__wrapper' onClick={(e) => e.target.id === 'student-onboarding-card-modal-fall-2023__wrapper' && checkForUnfinishedSubtasksAndThenProceed()}>
            {saving && (
                <div className='student-onboarding-card-modal-fall-2023__saving-overlay'>
                    <div className='student-onboarding-card-modal-fall-2023__saving-card'>
                        <div className='student-onboarding-card-modal-fall-2023__saving-spinner'></div>
                        <div className='student-onboarding-card-modal-fall-2023__saving-title'>Saving workflow</div>
                        <div className='student-onboarding-card-modal-fall-2023__saving-subtitle'>
                            Updating the onboarding card before closing.
                        </div>
                    </div>
                </div>
            )}
            {copyConfirmationPopup.show && <SimpleNotification approved={true} title={copyConfirmationPopup.title} style={simpleNotificationStyleObj} action={setCopyConfirmationPopup} show={copyConfirmationPopup.show} />}
            {areYouDonePopup && <LooksLikeYouAreDonePopup saveAndCloseTask={saveAndCloseTask} deleteAndCloseTask={deleteAndCloseTask} />}
            <div className='student-onboarding-card-modal-fall-2023__closing-x__gutter'>
                <div className='student-onboarding-card-modal-fall-2023__closing-x__wrapper'>
                    <MdClose onClick={() => checkForUnfinishedSubtasksAndThenProceed()} color='#334155' size={24}/>
                </div>
            </div>
            <div className='student-onboarding-card-modal-fall-2023__main-card'>
                <ModalAreaFall2023 
                    studentOnboardingModal={studentOnboardingModal} 
                    setOpenWorkflowModal2023={setStudentOnboardingModal} 
                    pushNewCardToOnBoardingCardsAndCloseModal={pushNewCardToOnBoardingCardsAndCloseModal}
                    pushNewCardAndRemoveOldCardAndCloseModal={pushNewCardAndRemoveOldCardAndCloseModal}
                    pushNewCardAndRemoveGhostLeavingCardAndCloseModal={pushNewCardAndRemoveGhostLeavingCardAndCloseModal}
                    updateExistingCardAndCloseModal={updateExistingCardAndCloseModal}
                    removedCardAndCloseModal={removedCardAndCloseModal}
                    removedCardAndCloseModalOpenConfirmationPopup={removedCardAndCloseModalOpenConfirmationPopup}
                    removeCardAndLaunchConfetti={removeCardAndLaunchConfetti}
                    getFamilyData={getFamilyData}
                    setWarningPopup={setWarningPopup}
                />
            </div>
            <div className='student-onboarding-card-modal-fall-2023__gutter-1'>
                <FamilyInfoGutter 
                    modalInfo={studentOnboardingModal} 
                    setModalInfo={setStudentOnboardingModal} 
                    setCopyConfirmationPopup={setCopyConfirmationPopup} 
                    setSchedulingHelperTeacherId={setSchedulingHelperTeacherId} 
                    teacherDistanceSuggestions={teacherDistanceSuggestions} 
                    setTeacherDistanceSuggestions={setTeacherDistanceSuggestions}
                    setFamilyProfile={setFamilyProfile}
                    familyProfile={familyProfile}
                    onOpenDistanceScheduler={() => setShowDistanceScheduler(true)}
                    onOpenBookingDemo={() => setShowBookingDemo(true)}
                />
            </div>
            <div className='student-onboarding-card-modal-fall-2023__notes-area'>
                <NoteAreaFall2023 
                    modalInfo={{id: studentOnboardingModal.todoId, type: studentOnboardingModal.whichList === 'leaving' ? 'familyId' : 'onboardingId', displayName: studentOnboardingModal.todoName}}  
                    userData={userData} 
                    createNoteFunc={createNoteFunc} 
                    school={studentOnboardingModal.whichSchool}
                />
            </div>
            
            <div className='student-onboarding-card-modal-fall-2023__gutter-scheduling-helper' style={schedulingHelperTeacherId ? {width: '270px', opacity: 1} : {width: 0, opacity: 0}}>
                <SchedulingHelper2024 
                    schedulingHelperTeacherId={schedulingHelperTeacherId}
                    setSchedulingHelperTeacherId={setSchedulingHelperTeacherId}
                    teacherDistanceSuggestions={teacherDistanceSuggestions} 
                />
            </div>
            {showDistanceScheduler && 
                <DistanceSchedulerFall2025 
                    modalInfo={studentOnboardingModal}
                    teacherDistanceSuggestions={teacherDistanceSuggestions}
                    familyProfile={familyProfile}
                    onClose={() => setShowDistanceScheduler(false)}
                />
            }
            {showBookingDemo && (
                <div className="booking-demo-overlay">
                    <div className="booking-demo-modal">
                        <CalendlyBookingDemo
                            driveTimeSuggestions={teacherDistanceSuggestions}
                            familyId={studentOnboardingModal?.familyId}
                            familyName={
                                (familyProfile && familyProfile.familyName) ||
                                studentOnboardingModal?.todoName ||
                                undefined
                            }
                            students={familyProfile?.students}
                            availability={familyProfile?.initialAvailability}
                            familyMessage={
                                familyProfile?.initialAvailabilityNotes &&
                                familyProfile.initialAvailabilityNotes.length > 0
                                    ? familyProfile.initialAvailabilityNotes
                                    : studentOnboardingModal?.todoDescription || ""
                            }
                            onClose={() => setShowBookingDemo(false)}
                        />
                    </div>
                </div>
            )}
        </div>
        </div>
    )
}
export default StudentOnboardingCardModalFall2023;
